import defaultTranslation from './default';

export type TranslationPack = Readonly<typeof defaultTranslation>;
export type Translation = Partial<typeof defaultTranslation>;

const create = (translations?: Translation): Readonly<TranslationPack> => {
  return Object.freeze({ ...defaultTranslation, ...translations });
};
export default create;

export const DefaultTranslation = create();

const rightToLeftLangs = [
  'ar',
  'arc',
  'ckb',
  'dv',
  'fa',
  'ha',
  'he',
  'khw',
  'ks',
  'ps',
  'ur',
  'yi'
];

export const direction = (localeTag: string): 'ltr' | 'rtl' => {
  return rightToLeftLangs.includes(localeTag.split('-')[0]) ? 'rtl' : 'ltr';
};
